import * as React from "react"
import * as _ from "lodash"
import { CardModalNotOkButton } from "../../../../../modal"
import * as Model from "../../../../../../model"
import AddAccountModalPresenter, { Names } from "./add-account-modal-presenter"
import { NotificationProps } from "../../../../../notification"

class AccountModal extends React.Component<AccountModalProps, State> {
	constructor(props) {
		super(props)
		this.state = {
			applyToLocalAuthorities: [],
			chapter: null,
			newAccount: this.copyAccount(props.account)
		}
	}

	componentWillReceiveProps(props: AccountModalProps) {
		const newAccount: Model.Account = this.copyAccount(props.account)
		this.setState({ newAccount })
	}

	render() {
		return <AddAccountModalPresenter
		account={this.state.newAccount}
		chapter={this.state.chapter}
		chapters={this.props.chapters}
		classes={this.props.classes}
		instruction={this.props.instruction}
		loading={this.props.loading}
		notification={this.props.notification}
		onChange={e => this.handleChange(e) }
		onClickAddAcountCloseButton={e => this.props.onClickAddAcountCloseButton(e)}
		onClickNotificationCloseButton={e => this.props.onClickNotificationCloseButton(e)}
		onClickFooterButton={(button, e) => this.handleClickFooterButton(button, e)}
		onSubmit={e => this.props.onSubmit(this.state.newAccount, this.state.chapter, e)} />
	}

	private copyAccount(account: Model.Account): Model.Account {
		return account
			? _.clone(account)
			: {
					addedOn: null,
					class: this.props.classes[0],
					defaultChapter: null,
					expense: true,
					id: null,
					label: "",
					number: "",
					operation: true,
					receipts: true,
					removedOn: null,
					template: true,
				}
	}

	private handleChange(e: React.SyntheticEvent<Element>) {
		const target = e.target as HTMLElement
		const account = this.state.newAccount
		const applyToLocalAuthorities: Model.LocalAuthority[] = []
		let   chapter: Model.Chapter = this.state.chapter
		if (this.isHTMLInputElement(target)) {
			switch (target.name) {
				case Names.Expense:
					account.expense = target.checked
					break;
				case Names.Label:
					account.label = target.value
					break;
				case Names.Number:
					account.number = target.value
					break;
				case Names.Operation:
					account.operation = "1" === target.value
					break;
				case Names.Receipts:
					account.receipts = target.checked
					break;
				case Names.Template:
					account.template = target.checked
					break;
			}
		} else if(this.isHTMLSelectElement(target)) {
			switch (target.name) {
				case Names.Class:
					account.class = this.props.classes.find(cl => cl.id === parseInt(target.value))
					break;
				case Names.DefaultChapter:
					chapter = this.props.chapters.find(ch => ch.id === parseInt(target.value))
					this.setState({ chapter })
					break;
			}
		}

		this.setState({ applyToLocalAuthorities, newAccount: account, chapter })
	}

	private handleClickFooterButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void {
		this.props.onClickAddAcountCloseButton(e)
	}

	private isHTMLInputElement(element: HTMLElement): element is HTMLInputElement {
		return "INPUT" === element.tagName.toLocaleUpperCase()
	}

	private isHTMLSelectElement(element: HTMLElement): element is HTMLSelectElement {
		return "SELECT" === element.tagName.toLocaleUpperCase()
	}
}

export default AccountModal

export interface AccountModalProps {
	account?: Model.Account
	accountExist?: boolean
	chapters: Model.Chapter[]
	classes: Model.Class[]
	instruction: Model.Instruction
	lacas: Model.LocalAuthorityChapterAccount[]
	loading: boolean
	loadingChapters: boolean
	localAuthority: Model.LocalAuthority
	notification?: NotificationProps
	onClickNotificationCloseButton(e: React.SyntheticEvent<Element>): void
	onClickAddAcountCloseButton(e: React.SyntheticEvent<Element>): void
	onSubmit(
		account: Model.Account,
		chapter: Model.Chapter,
		e: React.SyntheticEvent<Element>
	): void
}

interface State {
	applyToLocalAuthorities: Model.LocalAuthority[]
	chapter: Model.Chapter
	newAccount: Model.Account
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/instruction-card/instruction-list/add-account-modal/index.tsx